<div class="sk-three-bounce" [class.colored]="!backgroundColor"><div class="sk-child sk-bounce1" [style.background-color]="backgroundColor"></div><div class="sk-child sk-bounce2" [style.background-color]="backgroundColor"></div><div class="sk-child sk-bounce3" [style.background-color]="backgroundColor"></div></div>


// WEBPACK FOOTER //
// ./node_modules/ng-http-loader/components/sk-three-bounce/sk-three-bounce.component.d.ts.SkThreeBounceComponent.html